import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from 'seedly-component-library';
import Avatar from 'app/seedly-component-library/avatar-new';
import ButtonNew from 'seedly-component-library/button-new';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { openPostModal } from 'dispatcher/modalDispatcher';
import { profileImage } from 'theme';
import TextareaAutosize from 'react-textarea-autosize';
import { RootState } from 'reducer';

const MockDiscussionCard = () => {
  const dispatch = useDispatch();
  const textAreaRef = useRef(null);

  const image = useSelector((state: RootState) => state.auth.user.image);

  return (
    <div className="card" data-testid="mock-discussion-card">
      <div className="flex flex-col gap-4 w-full ">
        <p className="title-lg">Start A Discussion</p>
        <div className="rounded w-full p-2 bg-white border-neutral-400 border">
          <div className="flex flex-row gap-2 w-full">
            <Avatar src={image || profileImage.defaultImage} />
            <TextareaAutosize
              className="w-full min-h-[60px] outline-none resize-none"
              placeholder="What do you want to talk about?"
              maxRows={4}
              onFocus={() => {
                mixpanel.track(trackedEvents.DiscussionClicked, {
                  location: 'discussion_box',
                });
                dispatch(openPostModal());
                textAreaRef.current.blur();
              }}
              ref={textAreaRef}
            />
          </div>
        </div>
        <div className="flex flex-row w-full justify-between">
          <Checkbox
            name="anonymous"
            onChange={() => {
              dispatch(openPostModal());
            }}
          >
            Post anonymously
          </Checkbox>
          <ButtonNew disabled>Post</ButtonNew>
        </div>
      </div>
    </div>
  );
};

export default MockDiscussionCard;
